import { token } from "@may-i/mash-design-system";
import styled from "styled-components";

/**
 * 단축키 키 표기 칩. 단축키 가이드 패널(ShortcutGuide) + 추가/조정 가이드 하단 안내 등에서 공용 사용.
 */
export const Kbd = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 22px;
  padding: 0 6px;
  border-radius: 5px;
  border: 1px solid rgba(143, 149, 178, 0.4);
  border-bottom-width: 2px;
  background: #f5f6fa;
  font-family: Pretendard Variable, Pretendard, sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: ${token("colors.text.primary")};
`;
